@if (record.rule.operator === Operator.LastX) {
  <div class="d-flex spacing-4 align-items-center">
    <app-inputs
      Label=""
      [value]="(lastXDays ?? '').toString()"
      placeholder="Days"
      type="number"
      (onChange)="onNumericChange($event)" />
    <span class="primary-100 h4-bold">days</span>
  </div>
} @else {
  <app-inputs
    class="w-100"
    Label=""
    (click)="openCalendar()"
    [value]="formattedDate"
    placeholder="Select date(s)" />
}

@if (record.rule.operator !== Operator.LastX) {
  <div
    class="d-flex spacing-4 mat-datepicker-popup"
    [class.single-calander]="!isRange"
    *ngIf="calendarOpen">
    @if (isRange) {
      <app-calendar-range
        class="w-100"
        [selection]="selectedRange"
        (calendarRangeChanged)="handleCustomRangeChange($event)">
      </app-calendar-range>
    } @else {
      <app-calendar
        class="w-100"
        [selection]="selectedRange?.start"
        (onChange)="handleCalendarChange($event)">
      </app-calendar>
    }
  </div>
}
